import React from "react";
import { Tag } from "antd";
import { TAG_CONFIG } from "../../constants/adminBookingConstants";

/**
 * Status Tag Component
 * Displays a status tag (Active/Inactive) with appropriate styling
 * 
 * Active status is shown with a green "success" tag, while inactive
 * status is shown with a gray "default" tag.
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isActive - Whether the status is active
 * @param {string} [props.className] - Additional CSS classes
 */
const StatusTag = ({ isActive, className = "" }) => {
  return (
    <div
      className={className}
      style={{
        minWidth: `${TAG_CONFIG.MIN_WIDTH}px`,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      {isActive ? (
        <Tag color="success" style={{ margin: 0, fontWeight: 600 }}>
          ✓ Active
        </Tag>
      ) : (
        <Tag color="default" style={{ margin: 0, opacity: 0.6 }}>
          Inactive
        </Tag>
      )}
    </div>
  );
};

export default StatusTag;
